import {
  CHANGE_EXCLUDE_FILTER,
  CHANGE_MODAL_SEARCH,
  CHANGE_PAGE,
  CHANGE_SELECTION_DATA,
  CHANGE_SENDING_REMINDERS_COUNT,
  FETCH_QUICK_LAUNCH_ASYNC,
  GET_PARTICIPANTS_ASYNC,
  GET_PARTICIPANTS_INFO_ASYNC,
  SEARCH_PARTICIPANTS_INFO_ASYNC,
  SUBMIT_QUICK_LAUNCH_ASYNC,
  VALIDATE_SETUP_STEP,
} from './constants'

const getParticipantsInfo = () => ({ type: GET_PARTICIPANTS_INFO_ASYNC.INITIATE })
export const getParticipantsInfoSuccess = (data) => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.SUCCESS,
  payload: { data },
})
export const getParticipantsInfoError = (error) => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.ERROR,
  error,
})
export const getParticipantsInfoCancel = () => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.CANCEL,
})

export const validateStepFields = () => ({ type: VALIDATE_SETUP_STEP })

export const fetchQuickLaunch = () => ({
  type: FETCH_QUICK_LAUNCH_ASYNC.INITIATE,
})
export const fetchQuickLaunchSuccess = (data) => ({
  type: FETCH_QUICK_LAUNCH_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchQuickLaunchError = (error) => ({
  type: FETCH_QUICK_LAUNCH_ASYNC.ERROR,
  error,
})
export const fetchQuickLaunchCancel = () => ({
  type: FETCH_QUICK_LAUNCH_ASYNC.CANCEL,
})

export const submitQuickLaunch = (data) => ({
  type: SUBMIT_QUICK_LAUNCH_ASYNC.INITIATE,
  payload: { data },
})
export const submitQuickLaunchSuccess = (data) => ({
  type: SUBMIT_QUICK_LAUNCH_ASYNC.SUCCESS,
  payload: { data },
})
export const submitQuickLaunchError = (error) => ({
  type: SUBMIT_QUICK_LAUNCH_ASYNC.ERROR,
  error,
})
export const submitQuickLaunchCancel = () => ({
  type: SUBMIT_QUICK_LAUNCH_ASYNC.CANCEL,
})

export const getParticipants = () => ({
  type: GET_PARTICIPANTS_ASYNC.INITIATE,
})
export const getParticipantsSuccess = (data) => ({
  type: GET_PARTICIPANTS_ASYNC.SUCCESS,
  payload: { data },
})
export const getParticipantsError = (error) => ({
  type: GET_PARTICIPANTS_ASYNC.ERROR,
  error,
})
export const getParticipantsCancel = () => ({
  type: GET_PARTICIPANTS_ASYNC.CANCEL,
})

export const searchParticipantsInfo = (value) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.INITIATE,
  payload: { value },
})
export const searchParticipantsInfoSuccess = (data) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.SUCCESS,
  payload: { data },
})
export const searchParticipantsInfoError = (error) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.ERROR,
  error,
})
export const searchParticipantsInfoCancel = () => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.CANCEL,
})

const changeExcludeFilter = (value) => ({
  type: CHANGE_EXCLUDE_FILTER,
  payload: { value },
})
const changeModalSearch = (search) => ({
  type: CHANGE_MODAL_SEARCH,
  payload: { search },
})
const changePage = (page) => ({ type: CHANGE_PAGE, payload: { page } })
const changeSelectionData = (field, value) => ({
  type: CHANGE_SELECTION_DATA,
  payload: { field, value },
})
const changeSendingRemindersCount = (value) => ({
  type: CHANGE_SENDING_REMINDERS_COUNT,
  payload: { value },
})

export default {
  // to props
  getParticipantsInfo,
  validateStepFields,
  getParticipants,
  getParticipantsCancel,
  changeExcludeFilter,
  changeModalSearch,
  changePage,
  changeSelectionData,
  searchParticipantsInfo,
  searchParticipantsInfoCancel,
  changeSendingRemindersCount,
}
